import React from "react";
import { Avatar } from "@material-ui/core";
import "./bootstrap.min.css";
import "./Header.css";
import { useStateValue } from "./StateProvider";

function Header() {
  const [{ user }, dispatch] = useStateValue();
  return (
    <div className="header">
      <div className="row elementToAnimate">
        <div className="col-sm-9">
          <p className="name">
            SAD NAPOLEON <code>BLOG</code>
          </p>
        </div>
        <div className="col-sm-3 ava">
          <Avatar src={user.photoURL} />
          <h6 className="mar">{user.displayName}</h6>
        </div>
      </div>
      <div className="container">
        <div className="row row-content">
          <div className="col-sm-6">
            <div className="card card-cusus">
              <div className="card-body">
                <h3 className="card-title raleway elementToAnimate1">
                  What I Do
                </h3>
                <p className="card-text raleway fonty elementToAnimate1">
                  Hi, I'm Sad Napoleon 👋 I am a self-taught programmer that
                  does projects. As you can see, im as sad as napoleon is.
                  Please go again and check out my blog, feel free to post but
                  make it clean please.
                </p>
                <code>https://github.com/rohansingh20</code>
              </div>
            </div>
          </div>
          <div className="col-sm-5">
            <img
              className="img-fluid picture"
              src="https://static.independent.co.uk/s3fs-public/thumbnails/image/2014/05/20/18/pg-35-napoleon-1-dea-getty.jpg?width=1200"
              alt="napoleon img"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;
